import { render, staticRenderFns } from "./HDXPadecimientos.vue?vue&type=template&id=79eb01b9&scoped=true"
import script from "./HDXPadecimientos.vue?vue&type=script&lang=js"
export * from "./HDXPadecimientos.vue?vue&type=script&lang=js"
import style0 from "./HDXPadecimientos.vue?vue&type=style&index=0&id=79eb01b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eb01b9",
  null
  
)

export default component.exports